export default {
  attributes: `"code";"label";"hierarchy-code";"description";"example";"requirement-level";"type";"type-parameters";"variant";"default-value";"transformations";"validations";"update-delete"
Age;Age;Bouillies_bio_bebe;;;;LIST;LIST_CODE|Age;;FALSE;;;
Type_de_produits;Type de produits;Lait_infantile_bio;;;;LIST;LIST_CODE|Type_de_produits;;FALSE;;;
Type_de_produits;Type de produits;Preparations_vegetales_bebe;;;;LIST;LIST_CODE|Type_de_produits;;FALSE;;;
Type_de_lait;Type de lait;Lait_infantile_bio;;;;LIST;LIST_CODE|Type_de_lait;;FALSE;;;`,
  categories: `hierarchy-code;hierarchy-label;hierarchy-parent-code;update-delete
Boissons_bebe_fruitees;Boissons bébé fruitées;Boissons_bio_bebe;
Boissons_bebe_lactees;Boissons bébé lactées;Boissons_bio_bebe;
Coffrets_de_tisanes;Coffrets de tisanes;Tisane_Infusion;
Boissons_vegetales_pour_enfants;Boissons végétales pour enfants;Boissons_bio_bebe;`,
  values: `list-code;list-label;value-code;value-label;update-delete
Colour;Colour;red;Red;update`,
  mappings: `hierarchy-code;categories-id-gwz;attribut-code;attribut-value-code;update-delete
CHAUSSURES;257;Pointures;45;update`
};
